export enum Loading {
  translations,
  blocks,
}
